<template>
  <div id="windy" :hidden="hidden"></div>
</template>

<script>
// import 'leaflet'
// require('@/assets/js/windy/libBoot')

const options = {
  // Required: API key
  key: 'cswLGq6c4dlYCAtZAjaKYz2SSeaIQ9N8',

  // Put additional console output
  // verbose: process.env.NODE_ENV === 'development',
  verbose: false

  // Optional: Initial state of the map
  //lat: 50.4,
  //lon: 14.3,
  //zoom: 5,
}

// eslint-disable-next-line
  const BoatIcon = L.icon({
  iconUrl: 'https://s3-eu-west-1.amazonaws.com/file.usail.es/static/vessel-icon.svg',
  iconSize: [24, 24],
  iconAnchor: [12, 12],
  popupAnchor: [0, 0]
})

export default {
  name: 'WindyMap',

  props: {
    markers: {
      type: Array,
      required: false,
      default: function() {
        return []
      }
    },
    onMarkerClick: {
      type: Function,
      required: false,
      default: () => {}
    },
    positionsGeoJson: {
      type: Object,
      required: false,
      default: null
    },
    vessel: {
      type: Object,
      required: false,
      default: null
    },
    hidden: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function() {
    return {
      map: null,
      // eslint-disable-next-line
        markersGroup: L.layerGroup(),
      mapFirstPositionIsSet: false,
      positionsGeoJsonLayer: null
    }
  },

  computed: {
    mapLoaded: function() {
      if (this.map) {
        return this.map._loaded
      }

      return null
    },

    fullLoad: function() {
      return this.markers && this.markers.length > 0 && this.mapLoaded
    }
  },

  watch: {
    hidden: function(hidden) {
      if (!hidden) {
        setTimeout(() => {
          this.map.invalidateSize()
        }, 300)
      }
    },

    fullLoad: function(fullLoad) {
      if (!fullLoad) {
        return
      }

      this.initMap()
    },

    markers: function(newMarkers, oldMarkers) {
      let changed = false
      newMarkers.forEach((newMarker, index) => {
        if (typeof oldMarkers[index] === 'undefined' || newMarker.vessel.id !== oldMarkers[index].vessel.id) {
          changed = true
        }
      })

      if (changed) {
        if (this.fullLoad) {
          this.mapFirstPositionIsSet = false
          this.initMap()
        }
      }
    },

    positionsGeoJson: function(positionsGeoJson) {
      if (this.positionsGeoJsonLayer) {
        this.map.removeLayer(this.positionsGeoJsonLayer)
      }

      // eslint-disable-next-line
        this.positionsGeoJsonLayer = L.geoJson(positionsGeoJson, {
        color: '#ffffff',
        weight: 2
      }).addTo(this.map)
    },

    vessel: function(vessel) {
      if (vessel) {
        setTimeout(() => {
          this.refreshMapPosition(9)
          this.map.invalidateSize()
        }, 300)
      } else {
        this.refreshMapPosition()
        this.map.invalidateSize()
      }
    }
  },

  created() {
    if (!window.copy_of_W) {
      window.copy_of_W = Object.assign({}, window.W)
    }
    if (window.W.windyBoot) {
      window.W = Object.assign({}, window.copy_of_W)
    }

    // Initialize Windy API
    // eslint-disable-next-line
      windyInit(options, windyAPI => {
      // windyAPI is ready, and contain 'map', 'store',
      // 'picker' and other usefull stuff

      const { map } = windyAPI
      // .map is instance of Leaflet map

      this.map = map
      this.map.setMaxBounds(null)
      this.map.setMinZoom(1)

      // Handle some events. We need to update the rotation of icons ideally each time
      // leaflet re-renders. them.
      // map.on('zoom', this.updateIconStyle)
      map.on('zoomstart', this.removeLabels)
      map.on('zoomend', this.initMap)
      map.on('viewreset', this.initMap)
    })
  },

  beforeDestroy() {
    window.n = {}
    this.map.off()
    this.map.remove()
  },

  methods: {
    removeLabels: function() {
      const labels = document.getElementsByClassName('marker-label')
      while (labels[0]) {
        labels[0].parentNode.removeChild(labels[0])
      }
    },

    updateIconStyle: function() {
      this.removeLabels()
      for (const marker of this.markers) {
        if (marker.windyMarker && marker.windyMarker._icon) {
          const label = document.createElement('div')
          label.className = 'marker-label'
          label.innerHTML = marker.vessel.name
          label.style.transform = marker.windyMarker._icon.style.transform
          label.style.transform = label.style.transform.replace(/rotateZ\(.*\)/, '')

          marker.windyMarker._icon.parentNode.insertBefore(label, marker.windyMarker._icon.nextSibling)

          const heading = marker.vessel.latestPosition.trueHeading || marker.vessel.latestPosition.cog || 0
          if (marker.windyMarker._icon.style.transform.indexOf('rotateZ') === -1) {
            marker.windyMarker._icon.style.transform = `${marker.windyMarker._icon.style.transform} rotateZ(${heading ||
              0}deg)`
            marker.windyMarker._icon.style.transformOrigin = 'center'
          }
        }
      }
    },

    refreshMapPosition: function(zoom = 9) {
      if (this.map.getZoom() > zoom) {
        zoom = this.map.getZoom()
      }

      if (this.markers.length > 0) {
        if (this.vessel) {
          this.markers.forEach(marker => {
            if (marker.vessel.id === this.vessel.id) {
              this.map.setView([marker.position.lat, marker.position.lng], zoom)
            }
          })
        } else if (this.markers.length === 1) {
          this.map.setView([this.markers[0].position.lat, this.markers[0].position.lng])
        } else if (this.markers.length > 1) {
          this.map.fitBounds(
            // eslint-disable-next-line
            L.featureGroup(this.markersGroup.getLayers()).getBounds()
          )
        }
      }
    },

    initMap: function() {
      this.markersGroup.clearLayers()

      if (this.markers.length > 0) {
        this.markers.forEach(marker => {
          // eslint-disable-next-line
            const m = L.marker([marker.position.lat, marker.position.lng], {
            icon: BoatIcon,
            title: marker.vessel.name
          })

          m.on('click', () => {
            this.map.panTo(m.getLatLng())
            this.onMarkerClick(marker)
          })

          this.markersGroup.addLayer(m)

          marker.windyMarker = m
        })

        this.markersGroup.addTo(this.map)
      }

      if (false === this.mapFirstPositionIsSet) {
        this.refreshMapPosition()
        this.mapFirstPositionIsSet = true
      }

      this.updateIconStyle()
    }
  }
}
</script>

<style scoped lang="stylus">
#windy
  width 100%
  height 100%
  >>> .marker-label
    position absolute
    background #1E3932
    color: white
    padding 2px 10px
    font-size 0.9em
    text-align center
    border-radius 8px
    margin-top 18px
    width 80px
    min-width 80px
    margin-left -35px
    line-height 1.2em

  >>> #logo-wrapper
    width 100% !important
    height 100% !important


  >>> #logo
    top 5px !important;
    bottom auto !important
    left 15px !important
    right auto !important
    margin-left auto !important


>>> #bottom #progress-bar .progress-line
  width calc(100% - 140px) !important

>>> #bottom #progress-bar #playpause
  z-index 6 !important
</style>
